import { GetRequest, PostRequest } from "./HttpService";
import { baseUrl } from "./HttpService";

export const RequestConsultationPayment = async (gateway = "zarinpal") => {
  const data = await GetRequest(`/Consultation/request-payment/${gateway}`);
  return data;
};

export const GetUserConsultations = async () => {
  const response = await fetch(
    `${baseUrl}/Consultation/get-user-consultations`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(errorMessage);
  }
  return response;
};

export const GetDoctorConsultations = async (filter) => {
  const response = await PostRequest(
    "/Consultation/get-doctor-consultations",
    filter
  );
  return response;
};

export const GetDoctorConsultationsHistory = async (filter) => {
  const response = await PostRequest(
    "/Consultation/get-doctor-consultations-history",
    filter
  );
  return response;
};

export const AddConsultion = async (authority, gateway = null) => {
  const param = gateway ? `${authority}?gateway=${encodeURIComponent(gateway)}` : authority;
  const respone = await GetRequest("/Consultation/add-consultion", param);
  return respone;
};

export const HasConsultation = async () => {
  const respone = await GetRequest("/Consultation/has-consultion");
  return respone;
};

export const GetInitialChatInfo = async (sessionId) => {
  const respone = await GetRequest("/Consultation/chat-info", sessionId);
  return respone;
};

export const GetPreviousConsultationMessages = async (sessionId) => {
  const respone = await GetRequest(
    "/Consultation/chat-info",
    sessionId,
    "previous",
  );
  return respone;
};

export const CloseConsultation = async (sessionId) => {
  const respone = await GetRequest(
    "/Consultation/close-consultation",
    sessionId,
    null,
    false
  );
  return respone;
};

export const ReopenConsultation = async (sessionId) => {
  const respone = await GetRequest(
    "/Consultation/reopen-consultation",
    sessionId,
    null,
    false
  );
  return respone;
};

export const CreateConsultation = async (consultatioVM) => {
  return await PostRequest(
    "/Consultation/create-manual-consultation",
    consultatioVM
  );
};

// export const getBlogById = async (id) => {
//   const data = await GetRequest("/Consultation", id);
//   return data;
// };

// export const deleteBlogById = async (id) => {
//   const response = await DeleteRequest("/Consultation", id);
//   return response.data;
// };
